import { render, staticRenderFns } from "./signIn.vue?vue&type=template&id=5ca21e38&scoped=true&"
import script from "./signIn.vue?vue&type=script&lang=js&"
export * from "./signIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca21e38",
  null
  
)

export default component.exports